import { IStrings } from 'localization/IStrings';
import { QuickFilter } from '../SettlementProposalsCard';

export const createQfRecord = (strings: IStrings): Record<QuickFilter, string> => {
	return {
		all: strings.all,
		unhandled: strings.unhandled,
	};
};
